<template><section>
<div class="page">
  <div>
    <h2>
      Usage of your phone number and address book
    </h2>
    <p>
      We ask for phone numbers because that's how ToTok identifies ToTok  users, making it easier for you to message friends and family quickly.
    </p>
<h3>
  Your address book information
</h3>
    <p>
      ToTok users don't have access to your address book information unless you share a contact using the Contact feature in a chat. We value your privacy and we have not, do not and will not ever sell your personal information to anyone.
    </p>


  </div>
</div>
 </section>
</template>

<script>
    export default {
        components: {},
        data() {
            return {};
        },
        computed: {},
        methods: {}
    }
</script>
